import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
  successRemoveForm,
} from './actions';

export function* requestData({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'movimentacoeslubrificacoes', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteData({ payload }) {
  try {
    const { id, params, query } = payload;

    yield call(api.delete, `movimentacoeslubrificacoes/${id}`, {
      params: query,
    });
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'movimentacoeslubrificacoes', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/operlubrificacao');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `movimentacoeslubrificacoes/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'movimentacoeslubrificacoes', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operlubrificacao');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'movimentacoeslubrificacoes', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deletarCliente({ payload }) {
  try {
    const { data, params } = payload;

    let idoperacaoabastecimento = '';

    idoperacaoabastecimento = data.idmovimentacao;
    idoperacaoabastecimento = `${idoperacaoabastecimento}/${data.idposto}`;

    const justificativa = data.justificativa || '';

    const obj = {};
    obj.justificativa = justificativa;

    yield call(
      api.delete,
      `movimentacoeslubrificacoes/${idoperacaoabastecimento}`,
      { params: obj }
    );
    yield put(successRemoveForm({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
    history.push('/operlubrificacao');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@operacaoLubrificacao/DATA_IN_REQUEST', requestData),
  takeLatest('@operacaoLubrificacao/DELETE_DATA', deleteData),
  takeLatest('@operacaoLubrificacao/SUCCESS_REMOVE', requestData),
  takeLatest('@operacaoLubrificacao/SUCCESS_REMOVE_FORM', requestData),
  takeLatest('@operacaoLubrificacao/STORE_DATA', store),
  takeLatest('@operacaoLubrificacao/FIND_DATA', find),
  takeLatest('@operacaoLubrificacao/UPDATE_DATA', update),
  takeLatest(
    '@operacaoLubrificacao/DELETE_OPERACAOLUBRIFICACAO_CLIENTE',
    deletarCliente
  ),
  takeLatest('@operacaoLubrificacao/RECORD_FILTERING', applyedFilters),
]);
